<template>
    <!-- 文字组件下划线设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="是否添加下划线">
        <el-radio-group v-model="underline" size="small">
            <el-radio-button v-for="(item,index) in textUnderLineConfig"
                            :key="index" 
                            :label="item.label">
                            {{item.value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
// 导入文字下划线配置文件
import { textUnderLineConfig } from '@/assets/js/config_dictionary.js';
export default {
  mixins: [ mixValueWatch ],
  data () {
    return {
      textUnderLineConfig
    }
  },
  computed: {
    /** @name 下划线
     *  @description 将 underline 字段映射到当前 underline 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      underline: { 
        parent: i => i.renderOption,
        attr: "underline"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderTextUnderline.vue